import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function ListDModal() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.ListD1} listD1`}>
            <div className="title-box">
                <div className="title1">{t('presale.product.modals.listD1_ms1')}</div>
                <div className="title2">{t('presale.product.modals.listD1_ms2')}</div>
                <div className="title3">
                    {t.rich('presale.product.modals.listD1_ms3', {
                        line1: (child: any) => child,
                    })}
                </div>
                <div className="title4">
                    <div className="title4-box">
                        <div className="title4-ms1">3600W</div>
                        <div className="title4-ms2">{t('presale.product.modals.listD1_title1')}</div>
                    </div>
                    <div className="title4-box">
                        <div className="title4-ms1">{t('presale.product.modals.listD1_value2')}</div>
                        <div className="title4-ms2">{t('presale.product.modals.listD1_title2')}</div>
                    </div>
                </div>
            </div>
            <div className="content-box">
                <div className="box-1">
                    <EFPic name={['listd1-modal1.webp', 'listd1-modal1.png']} className="fullImgs" alt="" />
                    <div className="v-msg">{t('presale.product.modals.listD1_ms5')}</div>
                </div>
                <div className="box-1">
                    <EFPic name={['listd1-modal3.webp', 'listd1-modal3.png']} className="fullImgs" alt="" />
                    <div className="v-msg">{t('presale.product.modals.listD1_ms4')}</div>
                </div>
                <div className="video-box">
                    <EFVideo sources={['/video/mm100m/modal/listD1_1.webm', '/video/mm100/modal/listD1_1.mp4']} className="video" />
                </div>
                <div className="box-2">
                    <EFPic name={['listd1-modal4.webp', 'listd1-modal4.png']} className="fullImgs" alt={t('presale.product.modals.listD1_ms1')} />
                </div>
            </div>
        </div>
    );
}
